import { blockScrollOnBody, releaseScrollOnBody } from '../utils/body-lock'
import { getScrollPercent, throttle } from '../utils/functions'

const EXIT_POPUP_COOKIE_NAME = 'wt_exitpopup'
const EXIT_POPUP_ON_MOUSE_LEAVE_TIMEOUT = 8000
const EXIT_POPUP_SCROLL_TRESHOLD = 80 // as precentage

const wasExitPopupShown = (): boolean => !sessionStorage.getItem(EXIT_POPUP_COOKIE_NAME)

const closeButtonHandler = (): void => {
  const $landingForm = document.querySelector<HTMLDivElement>('[data-exit-popup]')
  $landingForm.hidden = true
  releaseScrollOnBody()
}

const openPopup = (): void => {
  if (wasExitPopupShown()) {
    const $landingForm = document.querySelector<HTMLDivElement>('[data-exit-popup]')
    $landingForm.hidden = false
    blockScrollOnBody()
    sessionStorage.setItem(EXIT_POPUP_COOKIE_NAME, '1')
  }
}

const handleScrollDetection = (event): void => {
  const userScrollAsPercentage = getScrollPercent(event)
  userScrollAsPercentage > EXIT_POPUP_SCROLL_TRESHOLD && openPopup()
}

const openExitpopupIfConditionsMeet = (): void => {
  // After 8 sec. if user move mouse outside body, trigger exit popup, but only once.
  setTimeout(() => {
    document.body.addEventListener('mouseleave', function cb(event) {
      openPopup()
      // Remove event after first launch to prevent multiple activations
      // Equivalent of once: true, but with IE11 support
      // @see https://developer.chrome.com/blog/addeventlistener-once/
      event.currentTarget.removeEventListener(event.type, cb)
    })
  }, EXIT_POPUP_ON_MOUSE_LEAVE_TIMEOUT)

  // If user scroll to percantage of screen height
  document.addEventListener('scroll', throttle(handleScrollDetection, 200))
}

const openExitpopupOnClick = (): void => {
  const $openButtons = document.querySelectorAll<HTMLDivElement>('[data-open-exit-popup]')
  const $landingForm = document.querySelector<HTMLDivElement>('[data-exit-popup]')

  if ($openButtons) {
    $openButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault()
        $landingForm.hidden = false
        blockScrollOnBody()
        sessionStorage.setItem(EXIT_POPUP_COOKIE_NAME, '1')
      })
    })
  }
}

const initExitPopup = (isOnlyClickListener = false): void => {
  const $landingForm = document.querySelector<HTMLDivElement>('[data-exit-popup]')
  const $closeButton = document.querySelector<HTMLButtonElement>('[data-close-exit-popup]')

  if ($landingForm && $closeButton) {
    if (!isOnlyClickListener) openExitpopupIfConditionsMeet()
    $closeButton.addEventListener('click', closeButtonHandler)
    openExitpopupOnClick()
  }
}

export default initExitPopup
